<template>
  <div class="user">
    <div class="photo">
      <center>
        <img width="200" src="/static/img/ICONOS/face-2.png"/>
      </center>
    </div>
    <div class="info">
      <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
           <span>
            {{usuario}}
             <b class="caret"></b>
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <li>
              <a href="javascript:void(0)" @click="cerrarSesion()">
                <span class="sidebar-mini">Mp</span>
                <span class="sidebar-normal">Cerrar sesión</span>
              </a>
            </li>

          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data () {
      return {
        isClosed: true,
        usuario : '',
      }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      },

      getUser(){
       this.usuario = localStorage.getItem('usuario')
      },
      cerrarSesion(){
        this.$router.push('/');
        localStorage.removeItem('token');
        localStorage.removeItem('rol');
        localStorage.removeItem('usuario');
      }
    },
    mounted(){
      this.getUser();
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue